import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const PieChartStatistics = ({ siteList = [], SDVList = [], chartLoader }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        width: 380,
        type: "pie",
      },
      labels: [],
      colors: [
        "#006400", // Dark green
        "#228B22", // Medium-dark green
        "#32CD32", // Medium green (LimeGreen)
        "#90EE90", // Light green
        "#CCFFCC"  // Very light green
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length > 0 && SDVList.length > 0) {
      setChartData((prevState) => ({
        ...prevState,
        series: SDVList,
        options: {
          ...prevState.options,
          labels: siteList,
        },
      }));
    }
  }, [siteList, SDVList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">SDV Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartData.series.length > 0 && (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="pie"
            width={380}
          />
        )}
    </div>
  );
};

export default PieChartStatistics;